module.exports = __webpack_public_path__ + "img/uni-Bosque.b4a34448.png";